import ReturnContent from "@/pages/(app)/returns/view/components/return-content/return-content";
import { useGetReturnRequestSuspense } from "@babackapp/private-api-client/client/use-get-return-request";
import { useActivityStream } from "@babackapp/private-api-client/client/use-activity-stream";
import { getSseConnectionId } from "@babackapp/private-api-client/client/sse-connection";
import { tokenManager } from "@babackapp/auth-client/utils";
import { toast } from "@babackapp/ui/components/sonner";
import { useParams } from "react-router-dom";
import { CurrentReturnRequestProvider } from "../utils/current-return-request-context";
import { LineItemsLoadingStateProvider } from "../utils/line-items-loading-state-context";

export default function ReturnPage() {
  const { returnId, shopId } = useParams<{
    returnId: string;
    shopId: string;
  }>();
  const { data: returnRequest } = useGetReturnRequestSuspense({
    shopId: shopId!,
    returnRequestId: returnId!,
  });
  const sseConnectionId = getSseConnectionId();

  useActivityStream({
    shopId: shopId!,
    returnRequestId: returnId!,
    enabled: true,
    sseConnectionId,
    getAccessToken: () => tokenManager.getAccessToken(),
    onNewActivity: () => {
      toast.info("New comment added");
    },
  });

  return (
    <CurrentReturnRequestProvider returnRequest={returnRequest}>
      <LineItemsLoadingStateProvider>
        <ReturnContent />
      </LineItemsLoadingStateProvider>
    </CurrentReturnRequestProvider>
  );
}
